module.exports = __webpack_public_path__ + "static/media/scroll7.5b886f00.png";